import React from "react";
import { TableCompData } from "../../../../components";
import EmptyTable from "../../../../components/Common/EmptyTable";
import { LoanStatusHeader } from "../../../../utils/TableHeader";
import TablePagination from "../../../../components/Table/Pagination";
import TableSkeletonLoader from "../../../../components/Common/TableSkeletonLoader";

export default function AllLoanStatus({
  name,
  loading,
  setPageNumber,
  pagination,
  ButtonArray,
  StatusBadgeArray,
  TableData,
}) {
  return (
    <div>
      <TableCompData
        marginBottom={"72px"}
        columns={LoanStatusHeader(ButtonArray, StatusBadgeArray)}
        data={TableData || []}
        progressPending={loading}
        progressComponent={
          <TableSkeletonLoader rows={10} columns={5} />
        }
        message={
          !loading && (
            <EmptyTable
              Message={`There are currently no ${name}`}
            />
          )
        }
        cellPadding="12px"
      />
      {!loading && TableData?.length > 0 && (
        <TablePagination
          marginTop={"0"}
          handlePageChange={setPageNumber}
          {...pagination}
        />
      )}
    </div>
  );
}
